import React from 'react';
import { Helmet } from 'react-helmet-async';
import LegalPageLayout from './LegalPageLayout';
import { Heart, MapPin, Mail, Users, Sparkles } from 'lucide-react';

const AboutPage = () => (
  <LegalPageLayout title="O društvu" eyebrow="Val Dotika" testid="about-page">
    <Helmet>
      <title>O društvu – Val Dotika</title>
      <meta name="description" content="Društvo Val Dotika – podpora družinam in otrokom skozi masažo dojenčkov IAIM in aurikuloterapijo." />
    </Helmet>

    <p className="text-lg">
      <span className="font-semibold">Društvo Val Dotika</span> je neprofitno društvo za podporo družinam in otrokom, ustanovljeno z željo, da ustvarimo prostor, kjer se mamice in dojenčki povežejo skozi dotik, blizino in pristno prisotnost.
    </p>

    <p>
      V središču našega delovanja je mednarodno priznana <span className="font-semibold">IAIM metoda masaže dojenčkov</span>, ki jo dopolnjujemo z nežno <span className="font-semibold">aurikuloterapijo</span> za mamice. Verjamemo, da ko mama čuti podporo, se to razlije tudi na otroka – zato k vsaki masaži dojenčka povabimo še mamičin mir.
    </p>

    <div className="grid sm:grid-cols-3 gap-4 py-4 not-prose">
      <div className="bg-white rounded-2xl p-5 border border-violet-100">
        <Users size={20} className="text-violet-900 mb-2" />
        <h3 className="font-serif text-lg text-stone-800 font-bold mb-1">Majhne skupine</h3>
        <p className="text-stone-600 text-sm leading-relaxed">Do 5 družin na srečanje za intimno in umirjeno vzdušje.</p>
      </div>
      <div className="bg-white rounded-2xl p-5 border border-beige-100">
        <Heart size={20} className="text-beige-700 mb-2" />
        <h3 className="font-serif text-lg text-stone-800 font-bold mb-1">Dve lokaciji</h3>
        <p className="text-stone-600 text-sm leading-relaxed">Srečujemo se v Kočevju in Ivančni Gorici.</p>
      </div>
      <div className="bg-white rounded-2xl p-5 border border-olive-100">
        <Sparkles size={20} className="text-olive-700 mb-2" />
        <h3 className="font-serif text-lg text-stone-800 font-bold mb-1">Certificirano</h3>
        <p className="text-stone-600 text-sm leading-relaxed">Špela je certificirana IAIM inštruktorica in izvajalka aurikuloterapije.</p>
      </div>
    </div>

    <h2 className="font-serif text-2xl text-stone-800 font-bold pt-2">Naše poslanstvo</h2>
    <p>
      Mamicam želimo prišepniti, da niso same – in jim dati orodja, s katerimi lažje razumejo svojega dojenčka in zaupajo sebi. Skozi dotik ne učimo le masaže; krepimo zaupanje, povezanost in mir, ki ostane tudi po koncu tečaja.
    </p>

    <h2 className="font-serif text-2xl text-stone-800 font-bold pt-2">Podatki o društvu</h2>
    <div className="bg-white rounded-2xl p-5 border border-violet-100 not-prose">
      <p className="font-semibold text-stone-800 mb-2">Društvo za podporo družinam in otrokom Val Dotika</p>
      <div className="space-y-2 text-sm text-stone-600">
        <div className="flex items-start gap-2">
          <MapPin size={14} className="text-violet-900 mt-0.5 flex-shrink-0" />
          <span>Ulica heroja Marinclja 6, 1330 Kočevje</span>
        </div>
        <div className="flex items-start gap-2">
          <Mail size={14} className="text-violet-900 mt-0.5 flex-shrink-0" />
          <a href="mailto:info@valdotika.si" className="hover:text-violet-900 transition-colors">info@valdotika.si</a>
        </div>
        <p className="text-xs text-stone-500 pt-1">
          Matična številka: 2947145000 &nbsp;·&nbsp; Davčna številka: 51988780
        </p>
      </div>
    </div>
  </LegalPageLayout>
);

export default AboutPage;
